import { jsx as _jsx } from "react/jsx-runtime";
/* eslint-disable @typescript-eslint/ban-ts-comment */ // @ts-nocheck - Exempt from typecheck; undergoing changes in a different branch
import React, { useEffect, useState, useCallback, useMemo, useRef } from 'react';
import { ReactGrid } from '@codametrix/grid';
import { Box } from '@chakra-ui/react';
import { getDataSource } from './data-grid-utils';
import { useDispatch } from 'react-redux';
import { CustomLoadingCellRenderer } from './custom-loading-cell-renderer';
const DataGrid = ({ rowData, columnDefs, onRowClicked, onSelectionChanged, onCellClicked, onRowSelected, gridOptions, serverSideInfiniteScroll, paginationPageSize, cacheBlockSize, filterableOptions, contentFilter, endpointData, loaderInfo, bodyObject, customHeader, height })=>{
    const [gridApi, setGridApi] = useState();
    const dispatch = useDispatch();
    useEffect(()=>{
        if ((filterableOptions || bodyObject) && endpointData?.endPoint && serverSideInfiniteScroll) {
            gridApi?.setGridOption('cacheBlockSize', paginationPageSize ?? 25);
            gridApi?.setGridOption('paginationPageSize', paginationPageSize ?? 25);
            const datasource = getDataSource(endpointData, filterableOptions, paginationPageSize ?? 25, dispatch, contentFilter, loaderInfo, bodyObject);
            gridApi?.setGridOption('serverSideDatasource', datasource);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        filterableOptions,
        gridApi,
        paginationPageSize,
        serverSideInfiniteScroll,
        contentFilter,
        bodyObject
    ]);
    const onGridReady = useCallback((params)=>{
        setGridApi(params.api);
    }, []);
    useEffect(()=>{
        if (gridApi && rowData) {
            gridApi.setGridOption('rowData', rowData);
        }
    }, [
        gridApi,
        rowData
    ]);
    const { defaultColDef: gridOptionsDefaultColDef, sortingOrder, ...restGridOptions } = gridOptions ?? {};
    const pageSize = paginationPageSize ?? 25;
    const agGridOptions = {
        columnDefs: columnDefs,
        domLayout: 'normal',
        defaultColDef: {
            flex: 1,
            lockPinned: true,
            sortable: true,
            ...sortingOrder && {
                sortingOrder
            },
            ...gridOptionsDefaultColDef
        },
        components: {
            agColumnHeader: customHeader
        },
        suppressMovableColumns: true,
        suppressCellFocus: true,
        suppressHorizontalScroll: true,
        pagination: true,
        paginationPageSize: pageSize,
        paginationPageSizeSelector: [
            25,
            50,
            100
        ],
        rowModelType: serverSideInfiniteScroll ? 'serverSide' : 'clientSide',
        ...serverSideInfiniteScroll && {
            cacheBlockSize: cacheBlockSize ?? 25
        },
        multiSortKey: 'ctrl',
        ...restGridOptions
    };
    const gridRef = useRef(null);
    useEffect(()=>{
        if (gridRef.current && gridRef.current.api) {
            gridRef.current.api.setGridOption('columnDefs', columnDefs);
        }
    }, [
        columnDefs
    ]);
    const loadingCellRenderer = useMemo(()=>{
        return CustomLoadingCellRenderer;
    }, []);
    return(// This container wraps the react grid because a height is required on the surrounding container for the 
    // ag grid stuff to calculate properly for the rows. There is an override prop for the component in case
    // someone needs to change height where it's used.
    // It is not included in the grid package itself because dashboard and service desk use different layout frameworks.
    /*#__PURE__*/ _jsx(Box, {
        className: "dashboard-data-grid",
        height: height ?? '100%',
        width: "100%",
        display: "flex",
        flexDirection: "column",
        flex: "1 1 0",
        minHeight: height ? 0 : "200px",
        children: /*#__PURE__*/ _jsx(ReactGrid, {
            rowData: rowData,
            ref: gridRef,
            gridOptions: agGridOptions,
            onGridReady: onGridReady,
            onRowClicked: onRowClicked,
            onRowSelected: onRowSelected,
            onCellClicked: onCellClicked,
            onSelectionChanged: onSelectionChanged,
            loadingCellRenderer: loadingCellRenderer,
            pagination: gridOptions?.pagination ?? true,
            paginationPageSize: gridOptions?.paginationPageSize || paginationPageSize
        })
    }));
};
const MemoizedDataGrid = /*#__PURE__*/ React.memo(DataGrid);
export { MemoizedDataGrid as DataGrid };
